import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class AttestationToken {
  expiresIn = 0
  token = ""
}

export const ATTESTATION_TOKEN_DESER: SchemaDeSer<AttestationToken> =
  new SchemaDeSerBuilder(AttestationToken)
    .ofInt("expiresIn")
    .ofString("token")
    .toDeSer()

export class Attestation {
  bufferTime = 0
  errorCode = 0
  geolocateIn = 0
}

export const ATTESTATION_DESER: SchemaDeSer<Attestation> =
  new SchemaDeSerBuilder(Attestation)
    .ofInt("bufferTime")
    .ofInt("errorCode")
    .ofInt("geolocateIn")
    .toDeSer()
